/**
 * HTTP client for the Nordex Rust backend API.
 * 
 * This file wraps @nordex/core API client with Vite environment configuration.
 */

import { setConfig } from "@nordex/core";
import { getStoredToken } from "./auth";
import { API_BASE_URL, WS_BASE_URL } from "./config";

// Configure @nordex/core at module load time
setConfig({
  apiBaseUrl: API_BASE_URL,
  wsBaseUrl: WS_BASE_URL,
  debug: import.meta.env.DEV,
  // Authentication: Get JWT token from localStorage
  getAuthToken: () => getStoredToken(),
});

// Re-export all APIs from @nordex/core
export {
  OrdersApi,
  PositionsApi,
  AccountsApi,
  MarketsApi,
  VlpApi,
  FillsApi,
  FundingApi,
  MarketStatsApi,
  DepositsApi,
  WithdrawalsApi,
  WithdrawalAddressesApi,
  UserApi,
  apiClient,
} from "@nordex/core";
